import { Component, Input } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  standalone: true,
  imports: [RouterLink],
})
export class LogoComponent extends BaseComponent {
  @Input() logoRightW = '40';
  @Input() logoLeftW = '43';
}
